/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AnalyzeInputs */

const en_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const es_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizar`)
};

const fr_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

const de_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysieren`)
};

const ja_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析`)
};

const zh_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析`)
};

const ar_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل`)
};

const id_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis`)
};

const it_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizza`)
};

const ru_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализировать`)
};

const pt_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisar`)
};

const ko_analyze = /** @type {(inputs: AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분석`)
};

/**
* | output |
* | --- |
* | "Analyze" |
*
* @param {AnalyzeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const analyze = /** @type {((inputs?: AnalyzeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AnalyzeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_analyze(inputs)
	if (locale === "es") return es_analyze(inputs)
	if (locale === "fr") return fr_analyze(inputs)
	if (locale === "de") return de_analyze(inputs)
	if (locale === "ja") return ja_analyze(inputs)
	if (locale === "zh") return zh_analyze(inputs)
	if (locale === "ar") return ar_analyze(inputs)
	if (locale === "id") return id_analyze(inputs)
	if (locale === "it") return it_analyze(inputs)
	if (locale === "ru") return ru_analyze(inputs)
	if (locale === "pt") return pt_analyze(inputs)
	return ko_analyze(inputs)
});